import { create } from 'zustand';

const OUTLINE_KEY = 'apiboo.documents.outlineOpen';

function readOutlineOpen() {
  try {
    return localStorage.getItem(OUTLINE_KEY) !== '0';
  } catch {
    return true;
  }
}

/**
 * Layout state of the document area (cards 2.4 + 2.6), per device:
 *
 * - `outlineOpen`: the "On this page" rail's own open/closed choice, kept
 *   across sessions (the rail still hides below 1100 px whatever this says);
 * - `overlayOpen`: below 900 px the Documents sidebar is an overlay, opened by
 *   the toolbar's sidebar button (or a breadcrumb reveal) and closed by
 *   Escape, a click outside, or opening a document.
 */
export const useDocsLayoutStore = create((set) => ({
  outlineOpen: readOutlineOpen(),
  setOutlineOpen: (open) => {
    try {
      localStorage.setItem(OUTLINE_KEY, open ? '1' : '0');
    } catch {
      /* remembered for this session only */
    }
    set({ outlineOpen: !!open });
  },
  overlayOpen: false,
  setOverlayOpen: (open) => set({ overlayOpen: !!open }),
  // One-shot "put this in the sidebar's search box" (a tag chip, card 2.3);
  // the nonce makes the same tag clicked twice apply twice.
  searchRequest: null,
  requestSidebarSearch: (query) => set((s) => ({ searchRequest: { query, nonce: (s.searchRequest?.nonce || 0) + 1 } })),
}));

/** Window width breakpoints of the document area (card 2.6). */
export const DOCS_BREAKPOINTS = Object.freeze({ outline: 1100, sidebar: 900 });
